// =============================================
// feedingFunctionality - Handles feeding logic when a food item is clicked
// =============================================
import { checkLocalSavedData, playExplosionAnimation } from "../levelManager"
import { displayTooltip } from "../levelManager"
import { destroyIndicator, displayTutorialHand } from "../levelManager"
import { phaserOverlay } from "../planetBlocker"

export function feedingFunctionality(cockpitScene, side, trayItemIndex) {
	//playUISound(cockpitScene, cockpitScene.soundManager, "Subtle click 1", 0.25)
	// cockpitScene.cockpitSoundHandler("Subtle click 1")
	//console.log(`==== FEEDING FUNCTION START ====`)
	console.log(
		`Feeding functionality called with side: ${side}, trayItemIndex: ${trayItemIndex}`,
	)

	// Initialize data
	cockpitScene.savedUserData = checkLocalSavedData()
	cockpitScene.savedLevel = cockpitScene.savedUserData?.userLevel || 0
	cockpitScene.savedMiniLevel = cockpitScene.savedUserData?.userMiniLevel || 0
	cockpitScene.currentPlanet = cockpitScene.savedUserData?.currentPlanet || 0

	if (cockpitScene.currentPlanet === 3 && cockpitScene.savedMiniLevel === 20) {
		cockpitScene.currentLeftCreature = 8
	}
	const prefix = side === "left" ? "L" : "R"
	const currentCreature =
		side === "left"
			? cockpitScene.currentLeftCreature
			: cockpitScene.currentRightCreature

	console.log(`Current creature ID: ${currentCreature}`)

	// Check early return conditions
	if (
		cockpitScene.currentPlanet === 1 &&
		cockpitScene.savedMiniLevel === 2 &&
		trayItemIndex !== 1 &&
		side === "left"
	) {
		cockpitScene.cockpitSoundHandler("Error3")
		return // Not correct food for creature01
	}
	if (
		cockpitScene.currentPlanet === 1 &&
		cockpitScene.savedMiniLevel === 8 &&
		side === "right" &&
		trayItemIndex !== 3
	) {
		cockpitScene.cockpitSoundHandler("Error3")
		return // Not correct food for creature02
	}
	if (
		cockpitScene.currentPlanet === 2 &&
		cockpitScene.savedMiniLevel === 2 &&
		trayItemIndex !== 3 &&
		side === "left"
	) {
		cockpitScene.cockpitSoundHandler("Error3")

		return // Not correct food for creature03
	}
	if (
		cockpitScene.currentPlanet === 2 &&
		cockpitScene.savedMiniLevel === 8 &&
		side === "right" &&
		trayItemIndex !== 4
	) {
		cockpitScene.cockpitSoundHandler("Error3")
		return // Not correct food for creature04
	}
	if (
		cockpitScene.currentPlanet === 2 &&
		cockpitScene.savedMiniLevel === 15 &&
		side === "left" &&
		trayItemIndex !== 1
	) {
		cockpitScene.cockpitSoundHandler("Error3")
		return // Not correct food for creature05
	}
	if (
		cockpitScene.currentPlanet === 3 &&
		cockpitScene.savedMiniLevel === 3 &&
		side === "left" &&
		(trayItemIndex !== 3 || trayItemIndex !== 4)
	) {
		cockpitScene.cockpitSoundHandler("Error3")
		return // Not correct food for creature06
	}
	if (
		cockpitScene.currentPlanet === 3 &&
		cockpitScene.savedMiniLevel === 13 &&
		side === "right" &&
		trayItemIndex !== 4
	) {
		cockpitScene.cockpitSoundHandler("Error3")
		return // Not correct food for creature07
	}
	if (
		cockpitScene.currentPlanet === 3 &&
		cockpitScene.savedMiniLevel === 20 &&
		side === "left" &&
		!(trayItemIndex === 2 || trayItemIndex === 3)
	) {
		console.log("Not correct food for creature08 + index: " + trayItemIndex)
		cockpitScene.cockpitSoundHandler("Error3")
		return // Not correct food for creature08
	}

	cockpitScene.cockpitSoundHandler("Click-pop1")

	// Determine which task grid to use
	let taskGridIndex
	if (cockpitScene.currentPlanet <= 2) {
		taskGridIndex = 0
	} else if (cockpitScene.currentPlanet === 3) {
		if (cockpitScene.savedMiniLevel === 5 && trayItemIndex === 3) {
			taskGridIndex = 0 // For food type 3
		}
		if (cockpitScene.savedMiniLevel === 5 && trayItemIndex === 4) {
			taskGridIndex = 1 // For food type 4
		}
		if (cockpitScene.savedMiniLevel === 13 && trayItemIndex === 4) {
			taskGridIndex = 0 // For food type 3
		}
		if (cockpitScene.savedMiniLevel === 20 && trayItemIndex === 3) {
			taskGridIndex = 0 // For food type 3
		}
		if (cockpitScene.savedMiniLevel === 20 && trayItemIndex === 2) {
			taskGridIndex = 1 // For food type 3
		}
	} else {
		taskGridIndex = 0
	}

	console.log(`Using task grid index: ${taskGridIndex}`)

	// Get creature data
	cockpitScene.creatureData = cockpitScene.cache.json.get("creatureData")
	const creature = cockpitScene.creatureData.creatures.find(
		({ index }) => index === currentCreature,
	)

	if (!creature) {
		console.error(
			`ERROR: Creature with ID ${currentCreature} not found in creatureData!`,
		)
		return // Early return if creature data not found
	}

	const foodTypes = creature.food || [] // Get valid food types for cockpitScene creature
	const foodAmounts = creature.foodAmount || []

	console.log(`Creature food amounts from data:`, foodAmounts)

	// Get the actual food item from the tray
	const trayItem =
		cockpitScene[`${prefix}FoodTrayItems`].getChildren()[trayItemIndex - 1]
	if (!trayItem) {
		console.error(`ERROR: Tray item at index ${trayItemIndex - 1} not found!`)
		return
	}
	const foodTexture = trayItem.texture.key // e.g. 'food01_thumb'

	console.log(`Food ID: ${trayItemIndex}, Current creature: ${currentCreature}`)
	console.log(`Valid food types for creature: ${foodTypes}`)

	// Skip food type validation - we only rely on the early return conditions above
	console.log(`Using food ${trayItemIndex} for creature ${currentCreature}`)

	// Initialize tracking for cockpitScene side if needed
	const trackingKey = `${prefix}FeedingData`

	// DEBUG: Log current tracking data
	if (cockpitScene[trackingKey]) {
		console.log(
			`Current ${trackingKey} tracking:`,
			JSON.stringify({
				creatureId: cockpitScene[trackingKey].currentCreatureId,
				allComplete: cockpitScene[trackingKey].allComplete,
				grids: Object.keys(cockpitScene[trackingKey].foodGrids).length,
			}),
		)
	} else {
		console.log(`No ${trackingKey} tracking exists yet`)
	}

	if (!cockpitScene[trackingKey]) {
		console.log(`Initializing new feeding data for ${side} side`)
		cockpitScene[trackingKey] = {
			foodGrids: {}, // Track data for each food type
			allComplete: false,
			currentCreatureId: currentCreature, // Track which creature we're feeding
		}
	}

	// IMPORTANT: Force reset tracking between level changes or when completing a full feeding cycle
	// cockpitScene addresses cases where the creature ID might stay the same but we need fresh feeding
	if (
		!cockpitScene[trackingKey] ||
		cockpitScene[trackingKey].currentCreatureId !== currentCreature ||
		cockpitScene[trackingKey].allComplete === true
	) {
		console.log(`Resetting feeding data for ${side} tube.`)
		console.log(
			`Previous creature: ${cockpitScene[trackingKey]?.currentCreatureId}, New creature: ${currentCreature}`,
		)
		console.log(
			`Previous complete status: ${cockpitScene[trackingKey]?.allComplete}`,
		)

		// Reset feeding data for cockpitScene side completely
		cockpitScene[trackingKey] = {
			foodGrids: {},
			allComplete: false,
			currentCreatureId: currentCreature,
		}

		// Reset all food slots to empty visual state
		const gridPrefix = `${prefix}FoodTaskGrid_`
		// Reset grid 0
		if (cockpitScene[`${gridPrefix}0`]) {
			console.log(
				`Resetting grid ${gridPrefix}0 with ${cockpitScene[`${gridPrefix}0`].getChildren().length
				} slots`,
			)
			cockpitScene[`${gridPrefix}0`].getChildren().forEach((slot) => {
				slot.setTexture("emptyFood")
			})
		} else {
			console.log(`Grid ${gridPrefix}0 not found!`)
		}

		// Reset grid 1 if it exists
		if (cockpitScene[`${gridPrefix}1`]) {
			console.log(
				`Resetting grid ${gridPrefix}1 with ${cockpitScene[`${gridPrefix}1`].getChildren().length
				} slots`,
			)
			cockpitScene[`${gridPrefix}1`].getChildren().forEach((slot) => {
				//slot.setTexture('emptyFood');
			})
		}

		// Also clear any fed images from previous creature
		const fedGroupKey = `${prefix}FedGroup`
		if (cockpitScene[fedGroupKey]) {
			console.log(
				`Clearing ${fedGroupKey} with ${cockpitScene[fedGroupKey].getChildren().length
				} items`,
			)
			cockpitScene[fedGroupKey].clear(true, true) // destroy all children
		} else {
			console.log(`Fed group ${fedGroupKey} not found!`)
		}
	}

	// Get the correct food grid for cockpitScene task grid index FIRST
	const gridName = `${prefix}FoodTaskGrid_${taskGridIndex}`
	if (!cockpitScene[gridName]) {
		cockpitScene.cockpitSoundHandler("Error3")

		// console.error(`ERROR: Food grid not found: ${gridName}`)
		return
	}

	const gridItems = cockpitScene[gridName].getChildren()
	console.log(`Grid ${gridName} has ${gridItems.length} slots available`)

	// Initialize tracking for cockpitScene specific task grid index with proper maxFood value
	if (!cockpitScene[trackingKey].foodGrids[taskGridIndex]) {
		// Determine the proper maxFood value for cockpitScene grid
		// Use the foodAmounts from creature data if available, otherwise default to number of slots in grid or 5
		const maxFood = foodAmounts[taskGridIndex]
			? parseInt(foodAmounts[taskGridIndex], 10)
			: Math.min(gridItems.length, 5)

		console.log(
			`Initializing tracking for grid ${taskGridIndex} with maxFood: ${maxFood}`,
		)

		cockpitScene[trackingKey].foodGrids[taskGridIndex] = {
			currentFed: 0,
			maxFood: maxFood,
			isComplete: false,
			filledSlots: [], // Track which slots are filled
		}
	}

	const foodTracking = cockpitScene[trackingKey].foodGrids[taskGridIndex]
	console.log(
		`Food tracking for grid ${taskGridIndex}:`,
		JSON.stringify({
			currentFed: foodTracking.currentFed,
			maxFood: foodTracking.maxFood,
			isComplete: foodTracking.isComplete,
			filledSlots: foodTracking.filledSlots,
		}),
	)

	// Skip if already completed cockpitScene food type
	if (foodTracking.isComplete) {
		console.log(
			`Food type ${trayItemIndex} for grid ${taskGridIndex} already completed`,
		)
		return
	}

	// Find the next empty slot in the grid
	let targetSlot = null
	let targetSlotIndex = -1

	// Look for first slot that hasn't been filled yet according to our tracking
	console.log(`Searching for empty slot in grid with ${gridItems.length} slots`)
	console.log(`Currently filled slots: ${foodTracking.filledSlots.join(", ")}`)

	for (let i = 0; i < gridItems.length; i++) {
		if (!foodTracking.filledSlots.includes(i)) {
			targetSlot = gridItems[i]
			targetSlotIndex = i
			console.log(`Found empty slot at index ${i}`)
			break
		}
	}

	// Safety check - if all slots seem filled but we haven't reached maxFood,
	// something might be wrong with our tracking - reset the filled slots
	if (!targetSlot && foodTracking.currentFed < foodTracking.maxFood) {
		console.log(
			`WARNING: All slots appear filled but currentFed (${foodTracking.currentFed}) < maxFood (${foodTracking.maxFood})`,
		)
		console.log(`Resetting filledSlots tracking for grid ${taskGridIndex}`)
		foodTracking.filledSlots = []

		// Try finding a slot again
		for (let i = 0; i < gridItems.length; i++) {
			targetSlot = gridItems[i]
			targetSlotIndex = i
			console.log(`After reset: Using slot at index ${i}`)
			break
		}
	}

	if (!targetSlot) {
		console.error(`ERROR: No empty slot found in grid ${gridName}`)
		// Emergency reset of tracking data for cockpitScene grid as a last resort
		console.log(`EMERGENCY RESET of tracking data for ${gridName}`)
		cockpitScene[trackingKey].foodGrids[taskGridIndex] = {
			currentFed: 0,
			maxFood: foodAmounts[taskGridIndex]
				? parseInt(foodAmounts[taskGridIndex], 10)
				: Math.min(gridItems.length, 5),
			isComplete: false,
			filledSlots: [], // Reset filled slots
		}

		// Try to get the first slot
		if (gridItems.length > 0) {
			targetSlot = gridItems[0]
			targetSlotIndex = 0
			console.log(`After emergency reset: Using first slot`)
		} else {
			console.error(`CRITICAL ERROR: Grid has no slots even after reset!`)
			return
		}
	}

	// Increment fed count
	foodTracking.currentFed++
	// Track cockpitScene slot as filled
	foodTracking.filledSlots.push(targetSlotIndex)
	playExplosionAnimation(cockpitScene)
	console.log(
		`Using slot ${targetSlotIndex}, currentFed now ${foodTracking.currentFed}/${foodTracking.maxFood}`,
	)
	if (cockpitScene.currentPlanet === 1) {
		if (side === "left") {
			if (foodTracking.currentFed === 2) {
				//displayTooltip(cockpitScene, 250 * cockpitScene.scaleFactor, cockpitScene.gameH / 2 + 100 * cockpitScene.scaleFactor, 'medium', 'Down', 'Remember to keep feeding until every slot is full to ensure your creature is properly nourished!', 12);
				console.log("Displaying Feed Tooltip")

				displayTooltip(cockpitScene, {
					xPos: cockpitScene.radar.x - 400 * cockpitScene.scaleFactor,
					yPos: cockpitScene.radar.y + 100 * cockpitScene.scaleFactor,
					type: "downMediumBigTip",
					scale: 1,
					text: "Keep feeding\nuntil [b]every slot[/b] is full!",
					fontScale: -7,
					xTextOffset: 1,
					yTextOffset: 3,
				})

				cockpitScene.singleFoodOverlayRef.remove()

				const overlay = phaserOverlay(cockpitScene)

				const cutouts = [
					{
						x: cockpitScene.radar.x - 475 * cockpitScene.scaleFactor,
						y: cockpitScene.radar.y - 50 * cockpitScene.scaleFactor,
						width: 160 * cockpitScene.scaleFactor,
						height: 110 * cockpitScene.scaleFactor
					},
					{
						x: cockpitScene.foodTargetItemRef.x - cockpitScene.gameW - cockpitScene.foodTargetItemRef.width * cockpitScene.scaleFactor * 0.125,
						y: cockpitScene.foodTargetItemRef.y - cockpitScene.foodTargetItemRef.height * cockpitScene.scaleFactor * 0.125,
						width: cockpitScene.foodTargetItemRef.width * cockpitScene.scaleFactor * 0.25,
						height: cockpitScene.foodTargetItemRef.height * cockpitScene.scaleFactor * 0.25
					}
				]

				overlay.setMultipleCutouts(cutouts);
				// overlay.setTargetByCoords(
				// 	cockpitScene.radar.x - 475 * cockpitScene.scaleFactor,
				// 	cockpitScene.radar.y - 50 * cockpitScene.scaleFactor,
				// 	160 * cockpitScene.scaleFactor,
				// 	110 * cockpitScene.scaleFactor
				// )				

				cockpitScene.feedTrayOverlayRef = overlay
				displayTutorialHand(cockpitScene, {
					xPos: cockpitScene.foodTargetRef.x - cockpitScene.gameW,
					yPos: cockpitScene.foodTargetRef.y + 70 * cockpitScene.scaleFactor,
					rotation: 0
				})
				destroyIndicator(cockpitScene)

				overlay.setAboveOverlay([cockpitScene.tooltip, cockpitScene.tooltipText, cockpitScene.tutorialHand])
			}
		}
	}
	// Create fed image at the same position as the target slot
	const fedGroupKey = `${prefix}FedGroup`
	if (!cockpitScene[fedGroupKey]) {
		console.log(`Creating new fed group ${fedGroupKey}`)
		cockpitScene[fedGroupKey] = cockpitScene.add.group()
	}

	const xOffset = side === "left" ? cockpitScene.gameW : cockpitScene.gameW * 3

	const fedImage = cockpitScene.add
		.image(targetSlot.x - xOffset, targetSlot.y, foodTexture)
		.setScale(0)

	cockpitScene.tweens.add({
		targets: fedImage,
		scale: (cockpitScene.scaleFactor * 0.175),
		duration: 350,
		ease: "Back.Out",
	})

	fedImage.name = `fedImage_${taskGridIndex}_${foodTracking.currentFed}`
	cockpitScene[fedGroupKey].add(fedImage)

	// DO NOT change the texture of the target slot
	// Keep the original appearance of the slot

	// Check if cockpitScene food type is complete
	if (foodTracking.currentFed >= foodTracking.maxFood) {
		foodTracking.isComplete = true
		console.log(
			`Completed feeding for food type ${trayItemIndex} on grid ${taskGridIndex}`,
		)

		// Check if all food types are complete
		// Determine how many food grids we should be checking based on planet and level
		let requiredGrids = 1 // Default to 1

		// Special case for Planet 3, MiniLevel 5 which requires 2 food types
		if (cockpitScene.currentPlanet === 3 && cockpitScene.savedMiniLevel === 5) {
			requiredGrids = 2
		}
		if (
			cockpitScene.currentPlanet === 3 &&
			cockpitScene.savedMiniLevel === 20
		) {
			requiredGrids = 2
		}

		// Count how many grids are actually complete
		const completedGrids = Object.values(
			cockpitScene[trackingKey].foodGrids,
		).filter((grid) => grid.isComplete).length

		console.log(
			`Completed ${completedGrids} out of ${requiredGrids} required food grids`,
		)

		if (completedGrids >= requiredGrids) {
			console.log(`All feeding completed for ${side} side`)
			// Mark the entire side as complete
			cockpitScene[trackingKey].allComplete = true

			cockpitScene.feedingCompleted(trayItemIndex, side)
		}
	}

	//console.log(`==== FEEDING FUNCTION END ====`)
}
